
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"b","x1":"-154.14","y1":"494.11","x2":"-153.14","y2":"494.11","gradientTransform":"matrix(84.05 0 0 -90.43 12964.29 44731.3)","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#fff"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#cfe2f4"}})]),_c('mask',{attrs:{"id":"a","x":"8","y":"4.37","width":"84.05","height":"90.43","maskUnits":"userSpaceOnUse"}},[_c('path',{attrs:{"d":"M12.7 48C9.5 52.8 8 57.1 8 61c0 9 7.4 16.4 18.1 23.7 15.3 10.4 50.4 15.9 61 .3 3.4-5 4.9-13.9 5-23.9V61C92 39.8 85.3 13.3 74.9 6.2a10.9 10.9 0 00-6.4-1.8C51.1 4.4 22 34.4 12.7 48","fill":"#fff","fill-rule":"evenodd"}})])]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M12.7 48C9.5 52.8 8 57.1 8 61c0 9 7.4 16.4 18.1 23.7 15.3 10.4 50.4 15.9 61 .3 3.4-5 4.9-13.9 5-23.9V61C92 39.8 85.3 13.3 74.9 6.2a10.9 10.9 0 00-6.4-1.8C51.1 4.4 22 34.4 12.7 48","fill-rule":"evenodd","fill":"url(#b)"}})]),_c('path',{attrs:{"d":"M86.3 83.7H26.5a3.5 3.5 0 01-3.3-4.3l6.3-24.9a3.3 3.3 0 013.3-2.6h47.3a3.5 3.5 0 013.3 2.6l6.2 24.9a3.5 3.5 0 01-3.3 4.3","fill":"#b2d3ef","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M86.4 83.7a3.4 3.4 0 003.2-4.3l-6-24.7a3.3 3.3 0 00-3.2-2.6H57zM55 52.1H32.8a3.3 3.3 0 00-3.3 2.5l-3.1 12.3z","fill":"#4e84f9","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M56.4 51.4a8.4 8.4 0 118.4-8.4 8.5 8.5 0 01-8.4 8.4m0-23.5a16.3 16.3 0 00-16.2 16.3c0 5.8 1.7 8.1 10.2 19.2l5 6.7a1.4 1.4 0 001 .5 1.2 1.2 0 001-.5l5-6.6C70.9 52.3 72.7 50 72.7 44.2a16.3 16.3 0 00-16.3-16.3","fill":"#df4949","fill-rule":"evenodd"}})])
          )
        }
      }
    